export function squareMeterRound(squareMeters) {
  if (squareMeters < 0) return 0;

  const round = squareMeters > 10 ? 0 : 1;
  return +(squareMeters).toFixed(round);
};
